import { useState } from 'react'
import { Link, NavLink } from 'react-router-dom'

const NAV_ITEMS = [
  { label: 'Services', to: '/services' },
  { label: 'Workspace', to: '/workspace' },
  { label: 'Research', to: '/research' },
  { label: 'Notes', to: '/notes' },
  { label: 'About', to: '/about' },
  { label: 'Contact', to: '/contact' }
]

const linkClass = ({ isActive }) =>
  `flex min-h-11 items-center text-[15px] font-medium text-ink hover:underline underline-offset-4 ${
    isActive ? 'underline decoration-2 decoration-signal' : ''
  }`

export default function SiteHeader() {
  const [open, setOpen] = useState(false)

  return (
    <header className="border-b-2 border-ink bg-paper">
      <div className="mx-auto flex max-w-[1180px] flex-wrap items-center justify-between gap-x-8 px-4 py-2 sm:px-6">
        <Link
          to="/"
          onClick={() => setOpen(false)}
          className="flex min-h-11 items-center font-serif text-2xl font-bold text-ink no-underline"
        >
          Martin Tamm
        </Link>

        <button
          type="button"
          aria-expanded={open}
          aria-controls="site-nav"
          onClick={() => setOpen((o) => !o)}
          className="min-h-11 border-2 border-ink bg-paper px-4 font-mono text-xs font-semibold uppercase tracking-wider text-ink md:hidden"
        >
          Menu
        </button>

        <nav
          id="site-nav"
          aria-label="Main"
          className={`${open ? 'flex' : 'hidden'} w-full flex-col md:ml-auto md:flex md:w-auto md:flex-row md:gap-6`}
        >
          {NAV_ITEMS.map((item) => (
            <NavLink key={item.to} to={item.to} onClick={() => setOpen(false)} className={linkClass}>
              {item.label}
            </NavLink>
          ))}
        </nav>
      </div>
    </header>
  )
}
